import React from 'react';
import { Translator } from '~domain/i18n';
import { YouSetWebpageLinks } from '~frontend-common/routes';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';
import { colors } from '~ui-kit/theme/colors';
import { Box } from '../../box.component';
import { ExternalLink } from '../../external-link';
import { H3, Subtitle5 } from '../../typography.component';

interface FAQProps {
  translator: Translator;
  linkId?: string;
}

export function FAQ({ translator, linkId }: FAQProps) {
  const { t, getCurrentLanguageId } = translator;
  const faqPageURL = YouSetWebpageLinks[getCurrentLanguageId()].faq;

  return (
    <Box px={[3, 3, 1]} width={['100%']} flexDirection={'column'} alignItems="center" justifyContent="center">
      <H3 mb={2} color={colors.black} textAlign="center">
        {t('faq.title')}
      </H3>
      <Subtitle5 mt={1} color={colors.black} textAlign="center">
        {t('faq.description')}
      </Subtitle5>
      <StyledExternalLink id={linkId} mt={4} mx={1} color="primaryDark" to={faqPageURL}>
        {t('faq.visitFaq')}
      </StyledExternalLink>
    </Box>
  );
}

const StyledExternalLink = styled(ExternalLink)`
  font-weight: bold;
  text-decoration: underline;
  font-family: ${theme.fontFamily.poppins};
  font-size: 16px;
`;
